// extracted by mini-css-extract-plugin
export var searchHeader = "_53-0";
export var searchHeaderDark = "_53-1";